import { INIT_ROOT } from '../actionTypes';

export default function isMobile(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.deviceType === 'MOBILE';
    default:
      return state || false;
  }
}
